import React, { useState, useEffect } from 'react'
import {
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import rotas from '../services/rotas'
import rest from '../lib/rest'
import useCentralPrecos from '../lib/useCentralPrecos'

const CentralPrecos = ({ refresh }) => {

  const [listaCentral, setListaCentral] = useState([])

  // Lista tabela central
  const listaCentrais = () => {
    const retorno = rest.get(rotas.centralPrecos)
    retorno.then(ret => {
      if ((ret.success) && (ret.lista !== '')){
        let central = ret.lista
        setListaCentral(central)

        sessionStorage.setItem('id', central[0].filial_id)
        sessionStorage.setItem('filial', central[0].central)
        refresh(central[0].filial_id)

      }
    })

    return true
  }

  useEffect(() => {
    listaCentrais()
  },[])

  const centralClick = (e) =>{
    let id = e.target.id,
        filial = e.currentTarget.textContent

    useCentralPrecos.setCentral(id, filial)
    refresh(id)
  }

  return (
    <Col>
        <UncontrolledDropdown direction="left" group className="float-right">
        <DropdownToggle caret color="secondary" className="m-0 btn-central">
          {useCentralPrecos.central().filial}
        </DropdownToggle>
        <DropdownMenu className="dropMenu">
            <DropdownItem header className="dropHeader">Selecione a Central de Preços</DropdownItem>
            <DropdownItem divider />
            {listaCentral.map(item => <DropdownItem key={item.central_id} id={item.filial_id} onClick={centralClick}>{item.central}</DropdownItem>)}
        </DropdownMenu>
        </UncontrolledDropdown>
    </Col>
  )
}

export default CentralPrecos;